<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <modal size="medium"
         v-if="showModal"
         id="ModalConfirmationInvoice">

    <template v-slot:header>
      <h3 class="title">Confirmação dos Dados da Nota</h3>
    </template>

    <template v-slot:body>
      <div class="container">
        <div class="form-row" v-if="replace">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'"><strong>Nota a ser
            substituída:</strong></div>
          <div class="col-12 col-sm-6 f-w-700" :class="$appUtils.isMobile() ? 't-c' : 't-l'">
            <span>{{ $route.query.invoice_number }}</span>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'">(A) Valor Total do(s) Serviço(s):
          </div>
          <div class="col-12 col-sm-6 f-w-700 c-theme" :class="$appUtils.isMobile() ? 't-c' : 't-l'">R$
            <span>{{ entity.total_value }}</span></div>
        </div>
        <div class="form-row">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'">(B) Valor da(s) Deduçõe(s):</div>
          <div class="col-12 col-sm-6 f-w-700 c-orange" :class="$appUtils.isMobile() ? 't-c' : 't-l'">R$
            <span>{{
                entity.inference_value == null || entity.inference_value == '' || entity.inference_value == '0' ? '0,00' : entity.inference_value
              }}</span>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'">(C) Desconto Incondicionado:</div>
          <div class="col-12 col-sm-6 f-w-700 c-orange" :class="$appUtils.isMobile() ? 't-c' : 't-l'">R$
            <span>{{
                entity.unconditional_discount_value == null || entity.unconditional_discount_value == '' || entity.unconditional_discount_value == '0' ? '0,00' : entity.unconditional_discount_value
              }}</span>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'">(D) Base de Cálculo (A - B - C):
          </div>
          <div class="col-12 col-sm-6 f-w-700 c-theme" :class="$appUtils.isMobile() ? 't-c' : 't-l'">R$
            <span>{{ baseCalc }}</span></div>
        </div>
        <div class="form-row">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'">(E) Alíquota de Serviço:</div>
          <div class="col-12 col-sm-6 f-w-700 c-red" :class="$appUtils.isMobile() ? 't-c' : 't-l'">{{
              '100900100' === entity.service_code || '100901001' === entity.service_code ? 2 : 5
            }}%
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'">(F) Valor do ISS (D * E):</div>
          <div class="col-12 col-sm-6 f-w-700 c-red" :class="$appUtils.isMobile() ? 't-c' : 't-l'">R$
            <span>{{ entity.iss_value }}</span></div>
        </div>
        <div class="form-row">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'">(G) ISS Retido:</div>
          <div class="col-12 col-sm-6 f-w-700" :class="$appUtils.isMobile() ? 't-c' : 't-l'">Não se Aplica</div>
        </div>
        <div class="form-row">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'">(H) Valor Líquido:</div>
          <div class="col-12 col-sm-6 f-w-700 c-theme" :class="$appUtils.isMobile() ? 't-c' : 't-l'">
            <span>{{ entity.equity_value }}</span></div>
        </div>
        <div class="form-row">
          <div class="col-12 col-sm-6" :class="$appUtils.isMobile() ? 't-c' : 't-r'">(I) ISS Devido (F - G):</div>
          <div class="col-12 col-sm-6 f-w-700 c-red" :class="$appUtils.isMobile() ? 't-c' : 't-l'">R$
            <span>{{ entity.iss_value }}</span></div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button"
              :disabled="sending"
              @click="$emit('onSendInvoice')"
              class="btn btn-sm btn-theme-1 transit">
        <svg-icon :icon="sending ? 'sync' : 'check'" :svg-class="sending ? 'refresh rotate-1-seg' : ''"/>
        {{
          sending ? 'Aguarde, enviando...' : (replace ? 'Confirmar Substituição da NFS-e' : 'Confirmar Geração da NFS-e')
        }}
      </button>
      <button type="button"
              :disabled="sending"
              @click="$emit('onClose')"
              class="btn btn-sm btn-dark">
        <svg-icon icon="times"/>
        Fechar
      </button>
    </template>
  </modal>
</template>

<script>
import Big from "big.js";

export default {
  name: "ModalConfirmation",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    entity: {
      type: Object,
      default: {},
      required: true
    },
    sendingInvoice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      baseCalc: 0
    }
  },
  methods: {
    calculate() {
      let baseCalc = new Big(this.$appUtils.moneyToFloat(this.entity.total_value));
      baseCalc = baseCalc.minus(new Big(this.$appUtils.moneyToFloat(this.entity.inference_value)));
      baseCalc = baseCalc.minus(new Big(this.$appUtils.moneyToFloat(this.entity.unconditional_discount_value)));

      this.baseCalc = this.$appUtils.formatMoney(baseCalc.toString());

      // Define a alíquota baseada no código de serviço
      const aliquota = ('100900100' === this.entity.service_code || '100901001' === this.entity.service_code) ? "0.02" : "0.05";
      const iss = baseCalc.times(new Big(aliquota));
      this.entity.iss_value = this.$appUtils.formatMoney(iss.toString());
    }
  },
  computed: {
    showModal() {
      this.calculate();
      return this.show
    },
    sending() {
      return this.sendingInvoice
    },
    replace() {
      return this.$route.query.mode === 'replace';
    }
  }
}
</script>
<style lang="scss" scoped>
.transit {
  transition: all .3s ease;
}
</style>